import {isBefore, differenceInYears, parseISO} from 'ag-common/facades'

const getAusbildungsjahr = ausbildungsstart => {
  if (isBefore(new Date(), ausbildungsstart)) {
    return 0
  }
  return differenceInYears(new Date(), ausbildungsstart) + 1
}

export default getAusbildungsjahr
